import { useContext, useEffect, useState } from "react";
import { eENTITY, ePrivileges } from "../../../utils/enum";
import ServicePartnerList from "../data-management/service-partner/list";
import { UserContext } from "../../../context";
import Utils from "../../../utils";
import styles from "./entity.module.css";
import CustomerDataList from "../data-management/customer/list";

function EntityList() {
  const context: any = useContext(UserContext);
  const [activeEntity, setActiveEntity] = useState<string>("");

  useEffect(() => {
    setActiveEntity(
      Utils.isUserHasAccess(
        context.user?.privilegeList,
        ePrivileges.VIEWCUSTOMER
      )
        ? eENTITY.CUSTOMER
        : Utils.isUserHasAccess(
              context.user?.privilegeList,
              ePrivileges.VIEWSERVICEPARTNER
            )
          ? eENTITY.SERVICEPARTNER
          : ""
    );
  }, [context?.user]);

  const clearQueryParams = () => {
    const baseUrl = window.location.origin + window.location.pathname;
    window.history.replaceState(null, "", baseUrl); // Replace URL without query params
  };

  return (
    <div>
      <div className={styles.parentContainer}>
        {/* Check if user has permission to view customer menu */}
        {Utils.isUserHasAccess(
          context.user?.privilegeList,
          ePrivileges.VIEWCUSTOMER
        ) && (
          <div
            className={`${styles.tab} ${
              activeEntity === eENTITY.CUSTOMER ? styles.activeTab : ""
            }`}
            onClick={() => {
              clearQueryParams();
              setActiveEntity(eENTITY.CUSTOMER);
            }}
          >
            <span
              className={
                activeEntity === eENTITY.CUSTOMER
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              Customer
            </span>
          </div>
        )}
        {/* Check if user has permission to view service partner menu */}
        {Utils.isUserHasAccess(
          context.user?.privilegeList,
          ePrivileges.VIEWSERVICEPARTNER
        ) && (
          <div
            className={`${styles.tab} ${
              activeEntity === eENTITY.SERVICEPARTNER ? styles.activeTab : ""
            }`}
            onClick={() => {
              clearQueryParams();
              setActiveEntity(eENTITY.SERVICEPARTNER);
            }}
          >
            <span
              className={
                activeEntity === eENTITY.SERVICEPARTNER
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              Service Partner
            </span>
          </div>
        )}
      </div>
      <div>
        {activeEntity === eENTITY.CUSTOMER ? (
          <CustomerDataList />
        ) : activeEntity === eENTITY.SERVICEPARTNER ? (
          <ServicePartnerList />
        ) : null}
      </div>
    </div>
  );
}

export default EntityList;
